<template>
    <q-btn icon="filter list" v-if="this.filters && this.filters.length">
        <q-popover ref="filterPopover" persistent>
            <q-list separator link>
                <div class="full-width">
                    <q-item v-for="(field, index) in this.filters" :key="index">
                        <q-toggle v-if="field.component === 'v-checkbox'" class="full-width"
                            v-model="dynamicModels[`model${index}`]" :label="$T(field.label)" />
                        <q-datetime v-if="field.component === 'v-date'" class="full-width"
                            v-model="dynamicModels[`model${index}`]" :float-label="$T(field.label)" clearable type="date"
                            format="DD/MM/YYYY" />
                        <q-input v-if="field.component === 'v-field'" class="full-width"
                            v-model="dynamicModels[`model${index}`]" :float-label="$T(field.label)" clearable />
                        <q-select v-if="field.component === 'v-select'" class="full-width"
                            v-model="dynamicModels[`model${index}`]" :float-label="$T(field.label)" :options="getTranslatedOptions(field.data)"
                            clearable :filter="field.data.length >= 8" />
                    </q-item>
                </div>
                <div class="q-pa-md text-center">
                    <q-btn class="q-px-xl" outline @click="handleFilter" color="primary" size="form"
                        :label="$T('filter')" />
                </div>
                <div class="q-pa-s q-pb-md text-center">
                    <q-btn class="q-px-xl" outline @click="clearFilter" color="primary" size="form" :label="$T('clear')" />
                </div>
            </q-list>
        </q-popover>
    </q-btn>
</template>

<script>
import {
    QBtn,
    QPopover,
    QList,
    QItem,
    QToggle,
    QInput,
    QSelect
} from 'quasar-framework'
import axios from 'axios'

export default {
    name: 'VTableFilter',
    props: {
        slug: {
            required: true
        }
    },
    data() {
        return {
            filters: [],
            filtersToRefresh: {},
            dynamicModels: {},
            persistentPopover: true
        }
    },
    components: {
        QBtn,
        QPopover,
        QList,
        QItem
    },
    mounted() {
        if (this.filters) {
            for (let i = 0; i < this.filters.length; i++) {
                this.$set(this.dynamicModels, `model${i}`, '')
            }
        }
        this.init()
    },
    watch: {
      slug: 'init'
    },
    methods: {
        async init() {
            if (this.slug !== undefined) {
                await axios.get(`${config.appUrl}/api/${this.slug}/filter-list`).then((data) => {
                    this.filters = data.data.filters
                })
            }
        },
        getTranslatedOptions(options) {
            return options.map(option => ({
              label: this.$T(option.label.toLowerCase()),
              value: option.value,
            }));
        },
        handleFilter() {
            this.filtersToRefresh = {};
            this.filters.forEach((filter, index) => {
                for (const key in this.dynamicModels) {
                    if (key.includes(index)) {
                      if (this.dynamicModels[key] !== '') {
                       let fielValue = this.dynamicModels[key]

                        if (filter.type === "whereDate"){
                          const dateValue = this.dynamicModels[key];
                          dateValue.setTime(dateValue.getTime() - dateValue.getTimezoneOffset() * 60 * 1000);
                          fielValue = dateValue.toISOString().split('T')[0];
                        }

                        this.filtersToRefresh[`filter_${filter.field}`] = fielValue
                      }
                    }
                }
            })
            this.$emit('refreshTable', this.filtersToRefresh)
        },
        clearFilter() {
            this.dynamicModels = {};
            this.$emit('refreshTable', null)
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VTableFilter.vue